import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EaglesocietyService {
  BusSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public MakeES(FolioId: number | undefined): Observable<any> {
    this.BusSvcURL = this.appConfigService.busSvcURL;
    const EagleSocietyInfo: JSON = <JSON>(<unknown>{
      FolioId: FolioId,
      LoyaltyLevel: 'ES',
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.BusSvcURL + 'UpdateLoyaltyLevel',
      JSON.stringify(EagleSocietyInfo),
      { headers: headers }
    );
  }
}
